import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { uiShowModal } from 'src/store/actions/uiActions';
import { getOneReport, resetReports } from 'src/store/actions/reportActions';
import ReportLayout, {
  ReportHeader,
  ReportFooter,
} from 'src/layouts/ReportLayout';
import SymptomsReportList from 'src/uikit/SymptomsReportList';
import PageLoader from 'src/uikit/PageLoader';
import { Button } from 'src/uikit/Button';

const ReportPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('messages');
  const { id } = useParams();
  const { report, errors } = useSelector((state) => state.reportReducer);
  const [isLoading, setIsLoading] = useState(true);

  const handleNewReport = () => {
    const date = moment().format('YYYY-MM-DD');

    const record = report.records.find((rec) => rec.date === date) || null;

    dispatch(
      uiShowModal({
        type: record ? 'RECORD_EDIT_MODAL' : 'RECORD_NEW_MODAL',
        horseName: report.horse.name,
        date,
        ...(record ? { recordId: record.id } : { reportId: report.id }),
      }),
    );
  };

  const handleExportReport = () =>
    dispatch(
      uiShowModal({
        type: 'EXPORT_MODAL',
        id,
        horseName: report.horse.name,
        date: report.min_date,
      }),
    );

  useEffect(() => {
    if (!errors || !errors.status || errors.status !== 404) return;

    navigate('/not-found');
  }, [errors]);

  useEffect(() => {
    if (!report || !report.id) return;

    setIsLoading(false);
  }, [report]);

  useEffect(() => {
    if (!id) return;

    dispatch(getOneReport(id));
  }, [id]);

  useEffect(
    () => () => {
      dispatch(resetReports());
    },
    [],
  );

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <ReportLayout>
      <ReportHeader
        backLink="/diary"
        title={report.horse?.name}
        subtitle={`${moment(report.min_date).format('DD.MM.YYYY')} - ${moment(
          report.min_date,
        )
          .add(41, 'days')
          .format('DD.MM.YYYY')}`}
      />

      {report && report.id && <SymptomsReportList report={report} />}

      <ReportFooter>
        {moment.duration(moment().diff(moment(report.min_date))).asDays() <
          42 && (
          <Button
            type="button"
            variant="primary"
            label={t('actions.newReportLabel')}
            onClick={handleNewReport}
            disabled={
              !!report.records?.find(
                (rec) => rec.date === moment().format('YYYY-MM-DD'),
              )
            }
          />
        )}

        <Button
          type="button"
          variant="secondary"
          label={t('actions.exportLabel')}
          onClick={handleExportReport}
        />
      </ReportFooter>
    </ReportLayout>
  );
};

export default ReportPage;
